const EventId: { [key: string]: string } = {
    RegistrationInvalidOtp: '12103',
    RegistrationCouldNotCreateOtpTooManyRequests: '12102'
};

export default EventId;
